export type HotelPointsRuleScope =
  | 'service'
  | 'service_classification'
  | 'room_service'
  | 'experience'
  | 'activity'
  | 'tour'
  | 'survey'
  | 'feedback_form'
  | 'review_form'

export const HOTEL_POINTS_SCOPE_LABELS: Record<HotelPointsRuleScope, string> = {
  service: 'Serviço',
  service_classification: 'Classificação',
  room_service: 'Serviços Essenciais',
  experience: 'Experiência',
  activity: 'Atividade',
  tour: 'Passeio',
  survey: 'Pesquisa',
  feedback_form: 'Pesquisa',
  review_form: 'Opinião',
}

export const HOTEL_POINTS_VISIBLE_SCOPES: HotelPointsRuleScope[] = [
  'service',
  'service_classification',
  'room_service',
  'experience',
  'activity',
  'tour',
  // 'survey', // Pesquisa: não usamos no hotel
  'feedback_form',
  'review_form',
]

export const HOTEL_POINTS_SOURCE_LABELS: Record<string, string> = {
  service_order: 'OS',
  reservation_service: 'Reserva de serviço',
  room_service_order: 'Serviços Essenciais',
  tour: 'Passeio',
  experience: 'Experiência',
  activity: 'Atividade',
  survey: 'Pesquisa',
  feedback: 'Pesquisa',
  review: 'Opinião',
  reward: 'Recompensa',
  manual: 'Ajuste',
}

export const formatHotelPointsSource = (
  sourceType?: string | null,
  sourceId?: number | null
) => {
  if (!sourceType && !sourceId) return '-'
  const label = (sourceType && HOTEL_POINTS_SOURCE_LABELS[sourceType]) || sourceType
  if (label && sourceId) return `${label} #${sourceId}`
  return label || `#${sourceId}`
}
